import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const PlayIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-labelledby="titleId"
      aria-label="Play icon"
      {...props}
    >
      <path
        d="M6.93359 5.17114C7.10828 5.17116 7.28222 5.21861 7.43652 5.31274V5.31177L17.7217 11.5979C18.0095 11.7746 18.1836 12.0867 18.1836 12.4211C18.1835 12.7142 18.0495 12.9895 17.8242 13.1711L17.7217 13.2434L7.43652 19.5286C7.28219 19.6226 7.10698 19.6711 6.93359 19.6711C6.38739 19.6711 5.96875 19.2248 5.96875 18.7063L5.96875 6.13501C5.96875 5.62051 6.3836 5.17114 6.93359 5.17114Z"
        stroke="#202123"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default PlayIcon;
